import { Observable } from "rxjs";
import { ITokenPair } from "../../../features/auth/interface/dto/token-pair";
import { get, post } from "../../../service/api";
import {
    IListBuilderDetailsDto,
    IListBuilderDetailsBodyDto,
} from "../interface/dto/list-builder-details.dto";

export const fetchListBuilderDetails = (
    id: number,
    tokens: ITokenPair,
    email?: string,
): Observable<IListBuilderDetailsDto> =>
    get<IListBuilderDetailsDto>(
        `/list-builders/details/${id}`,
        email ? { email } : undefined,
        tokens,
    );

export const saveListBuilder = (
    data: IListBuilderDetailsBodyDto,
    tokens: ITokenPair,
    run?: boolean,
    email?: string,
): Observable<{ success: boolean }> =>
    post<{ success: boolean }, IListBuilderDetailsBodyDto>(
        "/list-builders",
        data,
        {
            ...(email && { email }),
            ...(run && { run }),
        },
        tokens,
    );

export const updateListBuilder = (
    id: number,
    data: IListBuilderDetailsBodyDto,
    tokens: ITokenPair,
    run?: boolean,
    email?: string,
): Observable<{ success: boolean }> =>
    post<{ success: boolean }, IListBuilderDetailsBodyDto>(
        `/list-builders/${id}`,
        data,
        {
            ...(email && { email }),
            ...(run && { run }),
        },
        tokens,
    );
